module.exports = __webpack_public_path__ + "img/Picture9.06fd4e14.png";